module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"no_permission":"No access"},"de":{"no_permission":"Kein Zugriff"},"it":{"no_permission":"Nessun accesso"},"fr":{"no_permission":"Aucun accès"}}')
  delete Component.options._Ctor
}
